import React, { Component } from "react";
import {
  Box,
  Grid,
  Button,
  Backdrop,
  Container,
  Typography,
  CircularProgress,
  Card,
  CardContent,
  TextField,
} from "@mui/material";
import * as Yup from "yup";
import { Formik } from "formik";
import { connect } from "react-redux";
import agent from "../../agent/agent";
import { showError, showSuccess } from "../../utils/notifications";
import { fetchGetUser } from "../../store/UserStore";

const initValues = {
  password: '',
  password_confirmation: ''
}

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, 'Пароль должен содержать минимум 8 символов')
    .matches(/[a-z]/, 'Пароль должен содержать минимум одну прописную латинскую букву')
    .matches(/[A-Z]/, 'Пароль должен содержать минимум одну заглавную латинскую букву')
    .matches(/[0-9]/, 'Пароль должен содержать минимум одну цифру')
    .matches(/[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/, 'Пароль должен содержать минимум один специальный символ')
    .required('Обязательно к заполнению'),
  password_confirmation: Yup.string()
    .oneOf([Yup.ref('password')], 'Пароли не совпадают')
    .required('Обязательно к заполнению'),
});

class Registration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isBackdrop: false
    };
  }

  onRegistration = async (values) => {
    await this.setState({ isBackdrop: true });
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token') || '';
    const body = {
      ...values,
      token: token,
      is_change_password: false
    };
    const resRegistration = await agent.post('/auth/registration', body)
      .then((res) => res.data).catch((err) => {
        return { error: err.response?.data?.details || 'Ошибка сервера, повторите попытку позднее.' }
      });
    if (resRegistration?.error) {
      await this.setState({ isBackdrop: false });
      showError('Ошибка регистрации', resRegistration?.error);
      return
    }

    showSuccess('Регистрация завершена', 'Пароль успешно установлен');
    window.location.href = '/'
  }

  render() {
    const {
      isBackdrop
    } = this.state;
    return (
      <Container maxWidth="sm">
        <Box py={4}>
          <Typography variant="h1" mb={1}>Завершение регистрации</Typography>
          <Card>
            <CardContent>
              <Formik
                initialValues={initValues}
                validationSchema={validationSchema}
                onSubmit={this.onRegistration}
              >{(props) => {
                const {
                  values,
                  errors,
                  touched,
                  handleSubmit,
                  handleChange
                } = props;
                return (
                  <Grid container spacing={2}>
                    <Grid size={12}>
                      <TextField
                        value={values.password}
                        type="password"
                        label="Пароль"
                        size="small"
                        name="password"
                        variant="outlined"
                        fullWidth
                        helperText={touched.password && errors.password}
                        error={Boolean(touched.password && errors.password)}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid size={12}>
                      <TextField
                        value={values.password_confirmation}
                        type="password"
                        label="Подтверждение пароля"
                        size="small"
                        name="password_confirmation"
                        variant="outlined"
                        fullWidth
                        helperText={touched.password_confirmation && errors.password_confirmation}
                        error={Boolean(touched.password_confirmation && errors.password_confirmation)}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid size={12}>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={handleSubmit}
                      >Завершить регистрацию</Button>
                    </Grid>
                  </Grid>
                )
              }}</Formik>
            </CardContent>
          </Card>
        </Box>

        <Backdrop open={isBackdrop}>
          <CircularProgress />
        </Backdrop>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
  fetchGetUser: () => dispatch(fetchGetUser())
});

export default connect(mapStateToProps, mapDispatchToProps)(Registration)
